<template>
  <div class="">
    <div class="">
      <div class="">
        <file-upload :url='url' :thumb-url='thumbUrl' btn-label="Upload Program Brochure" accept=".pdf" :headers="headers" @change="onFileChange"></file-upload>
      </div>
      <div class="">
        <img :src="singleProgram.image" alt="" width="100%">
        <div class="contact-stat">
          <my-upload
            field="file"
            v-model="showThumbnail"
            :width="830"
            :height="526"
            :url="thumbnailUrl()"
            @crop-upload-success="imageuploaded"
            :noCircle="true"
            lang-type="en">
          </my-upload>
          <v-btn :depressed="true" small block @click="showThumbnail = true">Program Thumbnail</v-btn>
        </div>
      </div>
      <div class="panel-body">
        <div class="contact-stat">
          <my-upload
            field="file"
            v-model="showSlider"
            :width="960"
            :height="480"
            :url="sliderUrl()"
            @crop-upload-success="imageuploaded"
            :noCircle="true"
            lang-type="en">
          </my-upload>
          <v-btn :depressed="true" small block @click="showSlider = true">Other Program Images</v-btn>
        </div>
        <v-layout row wrap>
          <v-flex lg4 md4 sm6 xs12 v-for="(image, key) in singleProgram.images" :key="key">
            <v-container>
              <img :src="image.image" alt="" width="100%" style="margin-bottom: 2%">
            </v-container>
          </v-flex>
        </v-layout>
      </div>

    </div>
  </div>
</template>

<script>
import ProgramVuex from '../../../mixins/Computed/Volunteer/ProgramsVuex'
import myUpload from 'vue-image-crop-upload'
export default {
  name: 'program-images',
  data () {
    return {
      showThumbnail: false,
      showSlider: false,
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('access_token') },
      filesUploaded: []
    }
  },
  computed: {
    url () {
      return this.$imageUniversalUrl() + ':5012/v1/pdf/upload/' + this.$route.params.program_id
    }
  },
  methods: {
    imageuploaded: function () {
      this.$store.dispatch('get_program', this.$route.params.program_id)
    },
    thumbnailUrl: function () {
      return this.$imageUniversalUrl() + ':5012/v1/profile/upload/' + this.$route.params.program_id
    },
    sliderUrl: function () {
      return this.$imageUniversalUrl() + ':5012/v1/images/upload/' + this.$route.params.program_id
    },
    thumbUrl (file) {
      return file.myThumbUrlProperty
    },
    onFileChange (file) {
      // Handle files like:
      this.fileUploaded = file
    }
  },
  components: {
    myUpload
  },
  mixins: [ProgramVuex]
}
</script>

<style scoped>

</style>
